var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":_vm.type}},[(_vm.title)?_c('h5',{staticStyle:{"color":"white"}},[_c('b',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }